import script from "./FoodItemEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodItemEditor.vue?vue&type=script&setup=true&lang=js"

import "./FoodItemEditor.vue?vue&type=style&index=0&id=69e69189&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e69189"]])

export default __exports__